import * as pdfjs from "pdfjs-dist/build/pdf";
import PdfjsWorker from "pdfjs-dist/build/pdf.worker?worker";
import createStore from "astrid-helpers/src/createStore";
import { onDocument } from "./document";
export const [getPdf, setPdf, usePdf, onPdf] = createStore();
pdfjs.GlobalWorkerOptions.workerPort = new PdfjsWorker();
onDocument(document => {
  if (document) {
    pdfjs.getDocument(document).promise.then(setPdf).catch(err => console.error(err));
    return () => setPdf();
  }
});
//# sourceMappingURL=pdf.js.map